/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetTransportColorsResponse } from '../../entities/v1/GetTransportColorsResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1TransportColorModelSchema } from './transportColorModelSchema'
import { z } from 'zod'

export const v1GetTransportColorsResponseSchema = z.object({
  transport_colors: z.array(z.lazy(() => v1TransportColorModelSchema)),
}) as unknown as ToZod<V1GetTransportColorsResponse>